module.exports = __webpack_public_path__ + "static/key-lethalleagueblaze-d4f9bcab88d200813089fbb7588fadb9.webp";